import React, { useState, useEffect, useRef } from "react";
import "./index.css";

import pic1 from "../../assets/1.png";
import pic2 from "../../assets/2.png";
import pic3 from "../../assets/3.png";
import pic4 from "../../assets/4.png";
import pic5 from "../../assets/5.png";
import pic6 from "../../assets/6.png";
import pic7 from "../../assets/7.png";
import pic8 from "../../assets/8.png";
import pic10 from "../../assets/10.png";
import pic11 from "../../assets/11.png";
import pic12 from "../../assets/12.png";
import pic13 from "../../assets/13.png";
import pic14 from "../../assets/14.png";
import pic15 from "../../assets/15.png";
import pic16 from "../../assets/16.png";
import pic17 from "../../assets/17.png";
import pic18 from "../../assets/18.png";
import pic19 from "../../assets/19.png";
import pic20 from "../../assets/20.png";
import pic21 from "../../assets/21.png";
import pic22 from "../../assets/22.png";
import pic23 from "../../assets/23.png";
import pic24 from "../../assets/24.png";
import pic25 from "../../assets/25.png";
import pic26 from "../../assets/26.png";
import pic27 from "../../assets/27.png";
import pic28 from "../../assets/28.png";
import pic29 from "../../assets/29.png";
import pic30 from "../../assets/30.png";
import pic31 from "../../assets/31.png";
import pic32 from "../../assets/32.png";
import pic33 from "../../assets/33.png";
import pic34 from "../../assets/34.png";
import pic35 from "../../assets/35.png";
import pic36 from "../../assets/36.png";
import pic37 from "../../assets/37.png";

import { FiExternalLink } from "react-icons/fi";
import { FaGithub } from "react-icons/fa";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const projectData = [
  {
    id: "01",
    digit: "1",
    title: "DEVSHIELD",
    description:
      "A secure banking platform that enables reliable financial transactions, emphasizes security and data integrity, and supports scalable cloud deployment.",
    tech: [
      "Java",
      "JavaScript",
      "React.js",
      "Spring",
      "MySQL",
      "REST APIs",
      "JWT",
      "Docker",
      "GitHub Actions",
      "AWS",
      "Postman",
    ],
    images: [pic33, pic26, pic31, pic32, pic30, pic27, pic28, pic29],
    link: "http://devshield.s3-website.us-east-2.amazonaws.com",
    github: "https://github.com/quantr10/DevShield-frontend",
  },

  {
    id: "02",
    digit: "2",
    title: "ITINERME",
    description:
      "An AI-driven travel planner that creates personalized multi-day itineraries in minutes, offering interactive maps, intelligent route suggestions, and real-time syncing for seamless editing and sharing on mobile.",
    tech: ["Flutter", "Firebase", "OpenAI API", "Google APIs"],
    images: [pic25, pic24, pic18, pic17, pic19, pic20, pic21, pic22, pic23],
    link: "#",
    github: "https://github.com/quantr10/ItinerMe",
  },
  {
    id: "03",
    digit: "3",
    title: "ECOXCHANGE",
    description:
      "A campus-focused platform designed to make sustainable living easier by helping DePauw students buy and sell secondhand items within a trusted community. EcoXchange encourages reuse, reduces waste, and makes everyday essentials more affordable.",
    tech: [
      "React.js",
      "Node.js",
      "Express.js",
      "Firebase",
      "REST APIs",
      "Stripe API",
      "Netlify",
      "Heroku",
    ],
    images: [pic16, pic10, pic11, pic12, pic13, pic14, pic15],
    link: "#",
    github: "https://github.com/quantr10/EcoXchange",
  },
  {
    id: "04",
    digit: "4",
    title: "BIZZUP",
    description:
      "A centralized web platform connecting users with local business combo deals through interactive location-based discovery, QR-code redemption, and a gamified rewards system to increase local business engagement and visibility.",
    tech: [
      "JavaScript",
      "React.js",
      "Firebase",
      "Google Maps API",
      "TailwindCSS",
      "Vercel",
    ],
    images: [pic5, pic6, pic7, pic34, pic35, pic36, pic37],
    link: "https://bizzup.vercel.app/",
    github: "https://github.com/quantr10/BizzUp",
  },
  {
    id: "05",
    digit: "5",
    title: "PAWRIDES",
    description:
      "A real-time ride-booking platform designed for the DePauw University community, offering live ride tracking, trip history management, and secure user authentication for a smooth and reliable campus transportation experience.",
    tech: [
      "HTML/CSS",
      "JavaScript",
      "React.js",
      "Firebase",
      "Bootstrap",
      "Vercel",
    ],
    images: [pic1, pic2, pic3, pic8, pic4],
    link: "https://pawrides.vercel.app/homepage/index.html#",
    github: "https://github.com/quantr10/Pawrides",
  },
];

const Projects = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  // NEW: separate slide index for each project
  const [slideIndexes, setSlideIndexes] = useState(projectData.map(() => 0));

  const sectionsRef = useRef([]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 900);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // DESKTOP scroll snap logic
  useEffect(() => {
    if (isMobile) return;

    const handleScroll = () => {
      const slides = sectionsRef.current;
      let closestIndex = 0;
      let closestDistance = Infinity;

      const viewportCenter = window.innerHeight / 2;

      slides.forEach((slide, i) => {
        const rect = slide.getBoundingClientRect();
        const slideCenter = rect.top + rect.height / 2;
        const distance = Math.abs(slideCenter - viewportCenter);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = i;
        }
      });

      setCurrentIndex(closestIndex);

      // reset slideshow when project changes on desktop
      setSlideIndexes(projectData.map(() => 0));
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, [isMobile]);

  // NEW: independent next/prev handlers
  const nextSlide = (projIndex, totalImages) => {
    setSlideIndexes((prev) => {
      const updated = [...prev];
      updated[projIndex] =
        updated[projIndex] === totalImages - 1 ? 0 : updated[projIndex] + 1;
      return updated;
    });
  };

  const prevSlide = (projIndex, totalImages) => {
    setSlideIndexes((prev) => {
      const updated = [...prev];
      updated[projIndex] =
        updated[projIndex] === 0 ? totalImages - 1 : updated[projIndex] - 1;
      return updated;
    });
  };

  const current = projectData[currentIndex];

  /* ---------------------------- MOBILE RENDER ---------------------------- */
  if (isMobile) {
    return (
      <section id="projects" className="scroll-projects mobile">
        <h1 className="projects-mobile-title">PROJECTS</h1>

        {projectData.map((p, i) => (
          <div key={i} className="mobile-project">
            <div className="big-number">
              <span className="digit-fixed">0</span>
              <span className="digit-flip">{p.digit}</span>
            </div>

            <h2 className="project-title-left">{p.title}</h2>

            <div className="tech-stack-left">
              {p.tech.map((t, idx) => (
                <React.Fragment key={idx}>
                  <span className="tech-item">{t}</span>
                  {idx !== p.tech.length - 1 && (
                    <span className="dot-separator"></span>
                  )}
                </React.Fragment>
              ))}
            </div>

            <p className="project-desc-left">{p.description}</p>

            <div className="slideshow-container mobile-slideshow">
              <div
                className="slide-track"
                style={{
                  transform: `translateX(-${slideIndexes[i] * 100}%)`,
                }}
              >
                {p.images.map((img, idx) => (
                  <img key={idx} className="slide-image" src={img} alt="" />
                ))}
              </div>

              <button
                className="slider-btn mobile-btn left"
                onClick={() => prevSlide(i, p.images.length)}
              >
                <FaChevronLeft />
              </button>

              <button
                className="slider-btn mobile-btn right"
                onClick={() => nextSlide(i, p.images.length)}
              >
                <FaChevronRight />
              </button>
            </div>

            <div className="links-left">
              <a
                href={p.link}
                target="_blank"
                rel="noreferrer noopener"
                className="slide-link"
                data-hover="LIVE"
              >
                <div className="slide-content">
                  <span className="link-text">LIVE</span>
                  <FiExternalLink className="link-icon" />
                </div>
              </a>

              <a
                href={p.github}
                target="_blank"
                rel="noreferrer noopener"
                className="slide-link"
                data-hover="GITHUB"
              >
                <div className="slide-content">
                  <span className="link-text">GITHUB</span>
                  <FaGithub className="link-icon" />
                </div>
              </a>
            </div>
          </div>
        ))}
      </section>
    );
  }

  /* ----------------------------- DESKTOP RENDER ----------------------------- */

  return (
    <section id="projects" className="scroll-projects">
      <div className="left-panel">
        <div className="left-hover-area">
          <div className="big-number">
            <span className="digit-fixed">0</span>
            <span key={current.digit} className="digit-flip">
              {current.digit}
            </span>
          </div>

          <h2 className="project-title-left">{current.title}</h2>

          <div className="tech-stack-left">
            {current.tech.map((t, i) => (
              <React.Fragment key={i}>
                <span className="tech-item">{t}</span>
                {i !== current.tech.length - 1 && (
                  <span className="dot-separator"></span>
                )}
              </React.Fragment>
            ))}
          </div>

          <p className="project-desc-left">{current.description}</p>

          <div className="links-left">
            <a
              href={current.link}
              target="_blank"
              rel="noreferrer noopener"
              className="slide-link"
              data-hover="LIVE"
            >
              <div className="slide-content">
                <span className="link-text">LIVE</span>
                <FiExternalLink className="link-icon" />
              </div>
            </a>

            <a
              href={current.github}
              target="_blank"
              rel="noreferrer noopener"
              className="slide-link"
              data-hover="GITHUB"
            >
              <div className="slide-content">
                <span className="link-text">GITHUB</span>
                <FaGithub className="link-icon" />
              </div>
            </a>
          </div>
        </div>
      </div>

      <div className="right-panel">
        <h1 className="right-sticky-title">PROJECTS</h1>

        {projectData.map((p, i) => (
          <section
            key={i}
            ref={(el) => (sectionsRef.current[i] = el)}
            className="project-slide"
          >
            <div className="slideshow-container">
              <div
                className="slide-track"
                style={{
                  transform: `translateX(-${
                    slideIndexes[currentIndex] * 100
                  }%)`,
                }}
              >
                {p.images.map((img, idx) => (
                  <img key={idx} className="slide-image" src={img} alt="" />
                ))}
              </div>

              <button
                className="slider-btn left"
                onClick={() => prevSlide(currentIndex, current.images.length)}
              >
                <FaChevronLeft />
              </button>

              <button
                className="slider-btn right"
                onClick={() => nextSlide(currentIndex, current.images.length)}
              >
                <FaChevronRight />
              </button>
            </div>
          </section>
        ))}
      </div>
    </section>
  );
};

export default Projects;
